import * as constants from '@/common/constants';
import { get, post, put, del } from '@/utils/http';

export const getAppstoreTreeList = (params) => {
    return get(constants.API_APPSTORE_TREE_LIST, params);
};

export const getAppstoreAppTreeList = (appId) => {
    return get(constants.API_APPSTORE_APP_TREE_LIST.replace(':appId', appId));
};

export const getAppListFromStoreByTreeNode = (params) => {
    return get(constants.API_APPSTORE_APP_LIST, params);
};

export const updAppCheckState = (params) => {
    return post(constants.API_APPSTORE_APP_CHECKSTATE_UPDE, params);
};

export const deleteAppFromStore = (id) => {
    return del(constants.API_APPSTORE_APP_DELETE.replace(':id', id));
};

export const addCopyAppToStoreByAppId = (appId) => {
    return post(constants.API_APPSTORE_APP_PUSH_TO_STORE, {appId});
};

export const getApplicationModelMenuListFromStore = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_APPSTORE_APP_MODELMENU_LIST, params);
};

/** 获取模型列表 */
export const getModelServiceListFromStore = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_APPSTORE_APP_MODEL_LIST, params);
};

export const getFormConfigFromStore = (id) => {
    return new Promise((resolve, reject) => {
        get(`${constants.API_APPSTORE_APP_FORM_TEMPLATE_DETAIL}/${id}`).then((result) => {
            if (result) {
                result.fieldsList = result.fieldsList.map(item => {
                    return item;
                });
            }
            resolve(result);
        }).catch(err => {
            reject(err);
        });
    });
};

export const installAppFromAppstoreByAppId = (params = {}) => {
    return post(constants.API_APPSTORE_APP_DOWN_FROM_STORE, params);
};

export const getApplicationModelTreeListFromStore = (params) => {
    return get(constants.API_APPSTORE_APP_MODELTREE_LIST, params);
};

export const getApplicationModelDetailFromStore = (modelId) => {
    return get(constants.API_APPSTORE_APP_MODEL_DETAIL.replace(':modelId', modelId));
};

/** 获取表单详情 */
export const getModelFormByIdFromStore = (modelId) => {
    return new Promise((resolve, reject) => {
        get(constants.API_APPSTORE_APP_MODEL_DETAIL_BYID.replace(':modelId', modelId)).then(res => {
            try {
                if (res.formObj) {
                    res.formObj.structure.forEach((item1, index1) => {
                        item1.fieldsList.forEach((item2, index2) => {
                            res.formObj.structure[index1].fieldsList[index2].formField = item2.id;
                        });
                    });
                }
            } catch (error) {
                reject(error);
            }
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
};

export const getModelFormReportListFromStore = (params = { currentPage: 1, pageSize: 10 }) => {
    // return get(constants.API_MODEL_FORM_REPORTLIST_LIST, params);
    return post(constants.API_APPSTORE_MODEL_FORM_REPORTLIST_LIST, params);
};

// 查看商店的应用介绍
export const getAppStoreAppDescribeOfStore = (appId) => {
    return get(constants.API_APPSTORE_APP_DES_OF_STOR.replace(':appId', appId));
};

// 查看应用介绍
export const getAppStoreAppDescribe = (appId) => {
    return get(constants.API_APPSTORE_APP_DES.replace(':appId', appId));
};

// 编辑应用介绍
export const saveAppStoreAppDescribe = (params) => {
    if (params.id === undefined || params.id === '') {
        return post(constants.API_APPSTORE_APP_DES_INSERT, params);
    } else {
        return put(constants.API_APPSTORE_APP_DES_UPD, params);
    }
};

// 获取体验应用的加密传参
export const getEncryptTenantId = () => {
    return get(constants.API_APPSTORE_ENCRYPT_TENANTID);
};

// 应用商店标签查询
export const getAppTypeList = (currentPage = 1, pageSize = 10, typeName) => {
    return get(constants.API_APPSTORE_APP_TYPE_LIST, { currentPage, pageSize, typeName: typeName });
};

// ================================================================================================
// 应用复制记录
export const getAppCopyRecordList = (currentPage = 1, pageSize = 10, searchKeyWord) => {
    return get(constants.API_STORE_APP_COPY_RECORD_LIST, { currentPage, pageSize, appName: searchKeyWord });
};
export const deleteAppCopyRecord = (id) => {
    return del(constants.API_STORE_APP_COPY_RECORD_DEL.replace(':id', id));
};
// 复制企业应用到仓库
export const dataAppCopy = (param) => {
    return post(constants.API_STORE_APP_COPY, param);
};
// 参数：treeNodeId,targetTenantId
export const copyBusinessTree = (param) => {
    return post(constants.API_STORE_COPY_BUSINESS_TREE, param);
};
// 参数：treeNodeId,targetTenantId
export const copyDictionaryTree = (param) => {
    return post(constants.API_STORE_COPY_DICTIONARY_TREE, param);
};
// 参数：treeNodeId,targetTenantId
export const copySerialNumberTree = (param) => {
    return post(constants.API_STORE_COPY_SERIALNUMBER_TREE, param);
};
// 参数：templateId,targetTenantId
export const copyArchiveTemplate = (param) => {
    return post(constants.API_STORE_COPY_ARCHIVE_TEMPLATE, param);
};
// 复制流程定义给客户
export const cloneProcessDefinitionToTenant = (targetTenantId, processDefinitionId) => {
    return post(constants.API_PROCESS_DEFINITION_CLONE_TO_TENANT, { targetTenantId, processDefinitionId });
};
// 复制指定应用下的流程定义给客户
export const processCloneToTenantByAppId = (id) => {
    return post(constants.API_PROCESS_DEFINITION_CLONE_TO_TENANT_BY_APPID, { id });
};
// 复制指定应用下的流程定义给客户
export const processServiceCopyByAppId = (id) => {
    return post(constants.API_PROCESS_SERVICE_COPY_TO_TENANT_BY_APPID, { id });
};
// 复制流程方案给目标企业
export const processServicePublic = (id) => {
    return post(constants.API_PROCESS_SERVICE_PUBLIC_COPY_TO_TENANT_BY_APPID, { id });
};
// 复制流程模板配置信息
export const copyProcessTemplateConfig = (id) => {
    return post(constants.API_PROCESS_TEMPLATE_CONFIG_COPY_TO_TENANT_BY_APPID, { id });
};
// 组件复制记录
export const getComponentCopyRecordList = (currentPage = 1, pageSize = 10, nAppId, oTreeNodeName) => {
    return get(constants.API_STORE_COMPONENT_COPY_RECORD_LIST, { currentPage, pageSize, nAppId: nAppId, oTreeNodeName: oTreeNodeName });
};
// 复制应用关联的审批流模板给客户
export const approvalTemplateCopyByAppId = (id) => {
    return post(constants.API_APPROVAL_TEMPLATE_COPY_TO_TENANT_BY_APPID.replace(':appCopyRecordId', id));
};
// 复制企业应用一键复制功能
export const dataAppCaseCopy = (param) => {
    return post(constants.API_STORE_APP_CASE_COPY, param);
};
// 应用方案记录
export const getAppCaseList = (param) => {
    return get(constants.API_STORE_APP_CASE_LIST, param);
};
// 从应用商店下载方案
export const downAppCase = (param) => {
    return post(constants.API_STORE_DOWN_APP_CASE, param);
};
// 应用方案下载限制
export const getAppCaseLimit = (param) => {
    return get(constants.API_STORE_APP_CASE_LIMIT, param);
};
// 参数，复制记录id
export const copyFormData = (param) => {
    return post(constants.API_STORE_FORM_DATA_COPY, param);
};



// WEBPACK FOOTER //
// ./src/data-model/appstore/appstore-model.js